import { Store } from './baseStore';
import { getUtk, getHSSC, getHSTC } from '../helpers/cookies';
import _logDebug from 'web-interactives-embed-framework/helpers/logDebug';
const logDebug = (...args) => {
  _logDebug('[models/Analytics]', ...args);
};
export class Analytics {
  constructor() {
    this._handleFetchSucceded = tracker => {
      this.store.setState(oldState => {
        const newState = {};
        newState.path = tracker.path;
        newState.referrerPath = tracker.referrerPath;
        newState.referrer = '';
        newState.analyticsPageId = tracker.pageId;
        newState.hsfp = tracker._getFingerprint();
        newState.canonicalUrl = tracker.canonicalUrl;
        newState.contentType = tracker.contentType;
        newState.pageId = Analytics.getPageId() || tracker.pageId;
        if (tracker.session) {
          newState.hssc = tracker.session.get();
        }
        if (tracker.utk) {
          newState.hstc = tracker.utk.get();
          newState.hutk = tracker.utk.visitor;
        }
        return Object.assign({}, oldState, newState, {
          isLoaded: true
        });
      });
    };
    // Setup analytics queue
    window._hsq = window._hsq || [];
    const initialState = {
      isLoaded: false,
      pageUrl: window.location.href,
      pageTitle: window.document.title,
      referrer: window.document.referrer,
      userAgent: window.navigator.userAgent,
      hutk: getUtk(),
      hssc: getHSSC(),
      hstc: getHSTC(),
      pageId: Analytics.getPageId()
    };
    this.store = new Store(initialState);
    this.fetchAnalytics();
  }
  fetchAnalytics() {
    this._analyticsQueue.push(this._handleFetchSucceded);
  }
  subscribe(listener) {
    return this.store.subscribe(listener);
  }
  get analytics() {
    return this.store.state;
  }
  track(props) {
    logDebug('Tracking analytics', props);
    this._analyticsQueue.push(props);
  }
  get _analyticsQueue() {
    return window._hsq;
  }
  static getPageId() {
    const pageVars = window.hsVars;
    if (pageVars && pageVars.analytics_page_id) {
      return pageVars.analytics_page_id;
    }
    if (pageVars && pageVars.page_id) {
      return pageVars.page_id;
    }
    return null;
  }
  static getLanguage() {
    const pageVars = window.hsVars;
    if (pageVars && pageVars.language) {
      return pageVars.language;
    }
    return null;
  }
}
const instance = new Analytics();
export default instance;